module.exports = __webpack_public_path__ + "static/media/excelicon.27d59cb4.svg";